/**
 *
 * LogoutPage
 *
 * Not actually a page, it just dispatches the logout action
 */

import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import React from 'react';

import session from '../App/session';

const LogoutPage = () => {
    const dispatch = useDispatch();
    dispatch(session.actions.destroySession());
    return <Navigate to="/login" replace />;
};

export default LogoutPage;
